<template>
  <div class="card">
    <div class="card-body position-relative">
      <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
      <template v-if="!loading">
        <div v-if="legendData"
             :class="{'alert p-1': true, legend_block: true, 'alert-success': !legendData.exceed, 'alert-danger': legendData.exceed}">
          <p v-if="legendData.exceed"><strong>{{ legendData.data.length }}</strong> раз(а) лимит достигнут</p>
          <p v-else>Всегда в наличии*</p>
        </div>
        <Chart :options="chartOptionsDelayed"/>
      </template>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import {Chart} from 'highcharts-vue'

export default {
  props: ['drug'],
  components: {Chart},
  data() {
    return {
      loading: false,
      maxQty: 0,
      maxLimits: [
        {max: 3, notInRange: 1},
        {max: 7, notInRange: 2},
        {max: 10, notInRange: 3},
      ],
      legendData: null,
      trends: null,
      chartOptionsDelayed: {
        chart: {
          height: 300,
          // width: 1000,
          scrollablePlotArea: {
            // minWidth: 600,
            scrollPositionX: 1
          },
          // type: 'spline'
        },
        title: {
          text: 'Изменение остатков'
        },
        series: [
          {
            name: 'Склад мск',
            data: [],
            color: '#6cb5f9'
          },
        ],
        tooltip: {
          shared: true,
          crosshairs: true
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle'
        },
        yAxis: {
          title: {
            text: 'Количество на складе'
          },
        },
        xAxis: {
          // labels: {
          //   padding: 2,
          //   step: 1,
          //   formatter: function () {
          //     const label = this.axis.defaultLabelFormatter.call(this);
          //     console.log(label);
          //     return label;
          //   }
          // }
        },
      },
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getExceedLimits() {
      const sett = this.maxLimits.find((l) => l.max >= this.maxQty);
      const limit = sett?.notInRange ?? 3;
      console.log(sett, limit);
      return this.chartOptionsDelayed.series[0].data.reduce((acc, qty, i) => {
        if (qty < limit) {
          acc.exceed = true;
          acc.data.push({index: i, qty});
        }
        return acc;
      }, {exceed: false, data: []})
    },
    async getData() {
      this.loading = true;
      const storeId = 3;
      const {data} = await api.post('/new/stores/byrange', {
        store_id: storeId,
        range_month: 3,
        drug_id: this.drug?.id
      })
      if (data.success) {
        this.chartOptionsDelayed.xAxis.categories = data.dates.map((d) => d.label);
        const orders = data.orders.reduce((acc, o) => {
          acc[o.date] = o
          return acc;
        }, {});
        const invoices = data.invoices.reduce((acc, o) => {
          if (!acc[o.date]) acc[o.date] = [];
          acc[o.date].push(o)
          return acc;
        }, {});
        let value = data.store.storeData[storeId] ?? 0;
        this.chartOptionsDelayed.series[0].data = data.dates.reduce((acc, d) => {
          let qty = value;
          qty -= +(orders[d.date]?.total ?? 0);
          if (invoices[d.date]) {
            invoices[d.date].forEach((i) => {
              if (i.store_out === storeId) {
                qty -= +i.total
              } else {
                qty += +i.total
              }
            })
          }
          // qty = +(invoices[d.date]?.total ?? 0);
          value = qty;
          acc.push(+qty);
          return acc;
        }, [])
        // console.log(this.chartOptionsDelayed.series[0].data);
        this.maxQty = Math.max(...this.chartOptionsDelayed.series[0].data);
        this.legendData = this.getExceedLimits()
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера', 'Ошибка!');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.legend_block p {
  margin-bottom: 0;
}

.legend_block {
  position: absolute;
  top: 10px;
  z-index: 9;
}
</style>
